import { useQuery } from "@origin-digital/query";
import { fetchDefaultSuggestions } from "../../../services/search/defaultSuggestionsService";
import { DefaultSuggestionsResponse } from "../../../services/categories/types";

const EMPTY: DefaultSuggestionsResponse = {
  faqs: [],
  quickActions: [],
  popularArticles: [],
};

export const useDefaultSuggestions = (enabled: boolean) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["search-default-suggestions"],
    queryFn: fetchDefaultSuggestions,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    ...(data ?? EMPTY),
    isLoading,
    isError,
  };
};
